export const EASE = [0.22, 1, 0.36, 1] as const;
